export const markers = [
    {
        id: "1",
        title: 'Turaidas iela 10, Sigulda, Siguldas pilsēta, LV-2150, Latvia',
        name: 'Turaidas castle',
        position: { lat: 57.182273, lng: 24.850391 },
        type: 'castle'
    },
    {
        id: "2",
        title: 'Gulbenes novads, Stāmerienas pagasts, Vecstāmeriena, LV-4406',
        name: 'Stameriena castle',
        position: { lat: 57.216338, lng: 26.899692 },
        type: 'castle'
    },
    {
        id: "3",
        title: 'Daugavas iela 38, Daugavpils, LV-5401, Latvia',
        name: 'Daugavpils Fortress',
        position: { lat: 55.882827, lng: 26.495144 },
        type: 'castle'
    },
    {
        id: "4",
        title: 'Pilsrundāle, Rundāles pagasts, LV-3921, Latvia',
        name: 'Rundāle Palace',
        position: { lat: 56.413433, lng: 24.024491 },
        type: 'castle'
    },
    {
        id: "5",
        title: 'Vilces pagasts, LV-3026, Latvia',
        name: 'Blankenfelde',
        position: { lat: 56.344261, lng: 23.547240 },
        type: 'castle'
    },
    {
        id: "6",
        title: 'Cesvaines pilsēta, LV-4871, Latvia',
        name: 'Cesvaine palace',
        position: { lat: 56.969312, lng: 26.312596 },
        type: 'castle'
    }, {
        id: "7",
        title: 'Pils Laukums 9, Cesis 4101, Latvia',
        name: 'Cesis Medieval Castle',
        position: { lat: 57.313281, lng: 25.271366 },
        type: 'castle'
    }, {
        id: '8',
        title: 'Pils Street 18, Sigulda 2150, Latvia',
        name: 'Old Sigulda Castle',
        position: { lat: 57.166197, lng: 24.849783 },
        type: 'castle'
    }, {
        id: '9',
        title: 'Jana iela 17, Ventspils 3601, Latvia',
        name: 'The Castle of the Livonian order',
        position: { lat: 57.396155, lng: 21.558696 },
        type: 'castle'
    }, {
        id: '10',
        title: 'Pilskalns | Pilskalns, Bauska 3901, Latvia',
        name: 'Bauska Castle',
        position: { lat: 56.403553, lng: 24.174330 },
        type: 'castle'
    }, {
        id: '11',
        title: 'Jelgava, Latvia',
        name: 'Jelgava Palace',
        position: { lat: 56.651109, lng: 23.721354 },
        type: 'castle'
    }, {
        id: '12',
        title: 'Rigas - Ventspils sosejas 75km, Tukums, Latvia',
        name: 'Jaunmoku Castle',
        position: { lat: 56.981490, lng: 23.054284 },
        type: 'castle'
    }, {
        id: '13',
        title: 'Pils iela, Jaunpils 3145, Latvia',
        name: 'Jaunpils Castle',
        position: { lat: 56.728363, lng: 23.022226 },
        type: 'castle'
    }, {
        id: '14',
        title: 'Birini LV-4013, Latvia',
        name: 'Birini Castle',
        position: { lat: 57.249531, lng: 24.670151 },
        type: 'castle'
    }, {
        id: '15',
        title: 'Dobele, Latvia',
        name: 'Dobele Castle',
        position: { lat: 56.624906, lng: 23.279107 },
        type: 'castle'
    }, {
        id: '16',
        title: 'Pils Iela 14, Dundaga 3270, Latvia',
        name: 'Dundaga Castle',
        position: { lat: 57.510443, lng: 22.355259 },
        type: 'castle'
    }, {
        id: '17',
        title: 'Rigas iela 216b, Jekabpils 5202, Latvia',
        name: 'Krustpils castle',
        position: { lat: 56.511295, lng: 25.859054 },
        type: 'castle'
    }, {
        id: '18',
        title: 'Pils St. 6, Kraslava 5601, Latvia',
        name: 'Castle of Earls Platery',
        position: { lat: 55.899568, lng: 27.159682 },
        type: 'castle'
    }, {
        id: '19',
        title: 'Baldone, Latvia',
        name: 'Baldone White Castle',
        position: { lat: 56.745838, lng: 24.406107 },
        type: 'castle'
    }
];



// WEBPACK FOOTER //
// ./src/markers/markers.js